import React, { useEffect, useState } from "react";
import PageHeader from "../components/PageHeader";
import dots from "../assets/dots.svg";
import Dropdown from "react-bootstrap/Dropdown";
import { Link } from "react-router-dom";
import { deleteRole, roleList } from "../action/role";
import DeleteModal from "../components/DeleteModal";
const Role = () => {
  const [roles, setRoles] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [roleId, setRoleId] = useState("");
  const [deleteLoader, setDeleteLoader] = useState(false);

  const fetchRoles = async () => {
    try {
      const res = await roleList();
      if (res?.status) {
        setRoles(res.data.list);
      }
    } catch (error) {
      console.log("Error");
    }
  };

  const handleDelete = async () => {
    setDeleteLoader(true);
    try {
      const res = await deleteRole(roleId);
      if (res.status) {
        fetchRoles();
      }
    } catch (e) {
      console.log("Falied to delete", e);
    }
    setDeleteLoader(false);
    setShowDeleteModal(false);
    setRoleId("");
  };
  useEffect(() => {
    fetchRoles();
  }, []);
  return (
    <>
      <PageHeader pageTitle="Role" is_deploy_enable={false}>
        <Link to="/role/create-new-role" className="btn-black">
          Create Role
        </Link>
      </PageHeader>

      <div className="page-container">
        <div className="role-header mb-4">
          <div className="role-tabs">
            <Link to="/account" className="role-tab">
              Users
            </Link>
            <Link to="/role" className="role-tab active">
              Roles
            </Link>
          </div>
        </div>
        <div className="theme-card p-4">
          <div className="d-flex align-items-center mb-3">
            <div className="card-title pb-3">Roles</div>
            {/* <div className="sel-box ms-auto">
              <select name="selmenu" id="selmenu" className="theme-select">
                <option value="">Filter</option>
                <option value="">Filter Options</option>
              </select>
            </div> */}
          </div>
          <table className="pages-table">
            <thead>
              <tr>
                <th>Role Name</th>
                <th>Status</th>
                <th className="text-end" width="10%">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {roles &&
                roles.map((r, i) => {
                  return (
                    <tr key={i}>
                      <td key={i}>{r.name}</td>

                      <td>
                        <span className={`status ${r.is_active ? "success" : "danger" }`}>Active</span>
                      </td>
                      <td className="text-end" width="10%">
                        <Dropdown align="end">
                          <Dropdown.Toggle variant="button">
                            <button className="dotbtn">
                              <img src={dots} alt="" />
                            </button>
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="sm">
                            <Dropdown.Item as={Link} to={`/role/edit-role/${r._id}`}>
                              Edit
                            </Dropdown.Item>
                            <Dropdown.Item
                              as={Link}
                              to="#"
                              className="text-success"
                            >
                              Activate
                            </Dropdown.Item>
                            <Dropdown.Item
                              as={Link}
                              to="#"
                              className="text-danger"
                              onClick={() => {
                                setRoleId(r._id);
                                setShowDeleteModal(true);
                              }}
                            >
                              Deactivate
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
      <DeleteModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onDelete={handleDelete}
        deleting={deleteLoader}
      />
    </>
  );
};

export default Role;
